const o = "_root_wgog0_1", g = "_medium_wgog0_10", _ = "_large_wgog0_13", r = "_row_wgog0_17", t = "_right_wgog0_22", e = "_divider_wgog0_27", i = {
  root: o,
  medium: g,
  large: _,
  row: r,
  right: t,
  divider: e
};
export {
  i as default,
  e as divider,
  _ as large,
  g as medium,
  t as right,
  o as root,
  r as row
};
//# sourceMappingURL=index.es5450.js.map
